import { gantt } from '@replicon/dhtmlx-gantt';
import PropTypes from 'prop-types';
import React from 'react';
import {
  FocusableSpan,
  ProjectIcon,
  TaskIcon,
  TaskParentIcon
} from '~/modules/common/components';
import GanttTaskName2 from './GanttTaskName2';
import { isProject } from './util';

const TaskNameTemplate = ({ classes, task }) => {
  return (
    <div className={classes.ganttTaskNameContainer}>
      <FocusableSpan className={classes.taskIcon}>
        {isProject(task.$level) ? (
          <ProjectIcon />
        ) : gantt.hasChild(task.id) ? (
          <TaskParentIcon />
        ) : (
          <TaskIcon />
        )}
      </FocusableSpan>
      <GanttTaskName2 task={task} ariaLabel={task.text} />
    </div>
  );
};

TaskNameTemplate.propTypes = {
  classes: PropTypes.object,
  task: PropTypes.object
};

export default TaskNameTemplate;
